/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicALaCarteProducts.internal

import features.publicALaCarteProducts.models.PublicALaCarteProductsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class PublicAlaCarteProductsRequest : NetworkRequest() {

    suspend fun getPublicAlaCarteProducts(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<PublicALaCarteProductsModel> {
        return safeNetworkCall {
            get(
                endpoint = PublicAlaCarteProductsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
